import styled from '@emotion/styled'

// Interface for HStackContainer props
interface HStackContainerProps {
  disabled?: boolean
}

export const HStackContainer = styled.div<HStackContainerProps>`
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  align-items: center;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.2s ease;
  pointer-events: auto; // Changed from conditional to always auto to allow cursor to show

  &:hover {
    opacity: ${(props) => !props.disabled && 0.8};
  }
`
